import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import i18n from "i18next";

i18n
	.use(Backend) // Cargar las traducciones desde archivos
	.use(LanguageDetector) // Detecta el idioma automáticamente
	.use(initReactI18next) // Pasamos la instancia a react-i18next
	.init({
		fallbackLng: "es", // Idioma por defecto si no se detecta otro
		lng: "es", // Idioma inicial
		debug: true, // Para ver los logs en la consola durante el desarrollo
		interpolation: {
			escapeValue: false, // React ya hace escape en XSS
		},
		detection: {
			// Configuración del detector de idioma
			order: ["localStorage", "navigator"], // Orden para detectar el idioma: primero localStorage, luego navegador
			caches: ["localStorage"], // Guarda el idioma en localStorage
		},
		backend: {
			// Configuración para cargar archivos de traducción
			loadPath: "/locales/{{lng}}/translation.json", // Ruta de los archivos de traducción
		},
	});

export default i18n;
